import React from 'react';

const featureExplanations = {
  '67af2aa8904967c7df7076e2': (
    <div className="space-y-4 text-right" dir="rtl">
      <p>הפיצ'ר כבר זמין! ניתן להירשם בחינם ולקבל התראות ישירות לטלגרם על ירידות מחיר.</p>
      <div className="bg-blue-50 p-3 rounded-lg border border-blue-100">
        <p className="font-bold text-blue-800">איך נרשמים?</p>
        <p className="text-sm text-blue-700">
          נכנסים להגדרות המשתמש ומחברים את חשבון הטלגרם בלוחי אחת!
        </p>
      </div>
      <a href="/profile" className="inline-block text-blue-600 font-bold hover:underline">
        למעבר להגדרות פרופיל &rarr;
      </a>
    </div>
  ),
  // Add more mappings here as needed
};

export default featureExplanations;
